<template>
  <div id="add-new-item">
<v-dialog
      v-model="dialog"
      width="600">
      <!--
      <template v-slot:activator="{ on }">
        <v-btn color="primary" text @click="show()" v-on="on">{{text}}</v-btn>
      </template>
    -->

    <v-card  color="white" class="item" outlined >
      <v-card-title primary-title v-if="actualModel">
        Agregando {{actualModel.resource}}
      </v-card-title>
                  <v-card-text class="py-0 px-1">

                    <v-container class="pa-0" v-if="item">








                    <v-row no-gutters>
                      <v-col cols="12">
                            <v-row no-gutters v-if="actualModel">
                              <v-col class="pa-1" v-for="(input, index) in actualModel.inputs" v-if="input.nameAttr !== 'id'" :key="'h-'+index"> {{input.label}}</v-col>
                            </v-row>
                      </v-col>
                    </v-row>










                      <v-row no-gutters>

                        <v-col class="mr-3" v-for="(itemForm, index) in item.form" :key="index" v-show="itemForm.prop != 'id'">

                          <v-text-field
                          class="small"
                          v-if="itemForm.type == 'text'"
                          single-line
                          hide-details
                          outlined
                          :disabled="itemForm.disabled"
                          :name="itemForm.label"
                          :label="itemForm.label"
                          v-model="itemForm.value"
                          ></v-text-field>

                          <v-text-field
                          class="small"
                          v-if="itemForm.type == 'password'"
                          single-line
                          hide-details
                          outlined
                          type="password"
                          :disabled="itemForm.prop == 'id'"
                          :name="itemForm.label"
                          :label="itemForm.label"
                          v-model="itemForm.value"
                          ></v-text-field>

                          <v-textarea
                          class="small"
                          outlined
                          v-if="itemForm.type == 'textarea'"
                          single-line
                          hide-details
                          outlined
                          :disabled="itemForm.prop == 'id'"
                          :name="itemForm.label"
                          :label="itemForm.label"
                          v-model="itemForm.value"
                          ></v-textarea>


                          <v-select
                          class="small"
                          v-if="itemForm.type == 'select'"
                          single-line
                          hide-details
                          outlined
                          :items="itemForm.list"
                          item-text="nombre"
                          item-value="id"
                          :name="itemForm.label"
                          :label="itemForm.label"
                          v-model="itemForm.value"
                          :loading="itemForm.loading"
                          >

                          </v-select>

                          <v-select
                          class="small"
                          v-if="itemForm.type == 'multiSelect'"
                          single-line
                          hide-details
                          outlined
                          multiple
                          :items="itemForm.list"
                          :item-text="itemForm.itemText"
                          item-value="id"
                          :name="itemForm.label"
                          :label="itemForm.label"
                          v-model="itemForm.value"
                          :loading="itemForm.loading"
                          ></v-select>

                          <v-menu
                          v-if="itemForm.type == 'date'"
                          ref="menu"
                          :close-on-content-click="false"
                          :return-value.sync="date"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="290px"
                          >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                            class="small"
                            :loading="itemForm.loading"
                            single-line
                            hide-details
                            outlined
                            v-model="itemForm.value"
                            :label="itemForm.label"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                          v-model="itemForm.value"
                          no-title
                          scrollable
                          >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                          <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>


                      <!--
                    <v-col class="actions">


                      <div class="icon-content d-inline-block">
                        <v-btn :class="{
                          'green--text':!item.loading && item.isNew,
                          'orange--text':item.loading,
                          'red--text':item.saveError
                          }"
                          @click="saveItem(item)"
                          icon x-small
                          :loading="item.loading">
                          <v-icon>save</v-icon>
                        </v-btn>
                      </div>


                    </v-col>
                  -->




                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text>Cancelar</v-btn>
                <v-btn color="primary" @click="save()" :loading="loadingForm">Guardar</v-btn>
              </v-card-actions>

            </v-card>
    </v-dialog>

  </div>
</template>
<script>

import _ from "lodash";

export default {
  name: "addNewItem",
  props: ['text','model', 'value', 'item-form'],
  data: () => ({
    dialog      : false,
    models      : [],
    item        : null,
    listsModel  : [],
    actualModel : null,
    loadingForm : false
  }),
  computed:{
    empresaSelected(){
      return this.$store.getters.empresaSelected;
    },
    isMobile(){
      return this.$store.getters.isMobile;
    },
  },
  watch:{
    value(){
      console.log("value change");
      this.dialog = this.value;
      if(this.value){
        this.init();
      }
    },
    dialog(){
      console.log("dialog change");
      this.$emit("input", this.dialog);
    }
  },
  methods: {
    init() {
      //crear nuevo elemento
      if(this.model){
        this.importModel(this.model).then(model => {
          this.actualModel = model.default;
          this.item = this.actualModel.new();
          this.madeForm(this.item);
        })
      }
    },
    importModel(model){
      model = model || this.model.model;
      if(this.models[model]) return Promise.resolve(this.models[model]);
      return import('@/models/'+ model).then(modelRes => this.models[model] = modelRes)
    },

    madeForm(item){
      if(item == null || item == undefined) return;
      var self = this;
      var promises = [];
      item.form = null;


      //agrega relations al item
      if(this.actualModel.relations){
        _.forEach(this.actualModel.relations, attr => {
          var p = this.importModel(attr[0])
          .then(model => {
            var data = {};
            data[attr[1]] = item[[attr[2]]]; //id
            var valueObj = _.find(self.listsModel[attr[0]], data);
            if(valueObj){
              item[_.camelCase(model.default.resource)] = valueObj;
            }else{
              item[_.camelCase(model.default.resource)] = model.default.new();
            }
          })
          promises.push(p);
        })
      }
      //se usa promises, porque las relaciones deben estar hechas antes de hacer el formulario
      return Promise.all(promises).then(res => {
        var itemSelectedForm = this.actualModel.inputs.map( input =>{

          var obj = {
            disabled : input.disabled,
            required : input.required,
            label    : input.label,
            prop     : input.nameAttr,
            value    : _.get(item, input.nameAttr),
            type     : input.type,
            itemText : "nombre", // default
            loading : false,
            input   : input
          }

          //para detectar datos de otro modelo
          if (input.modelTo) {
            obj.modelTo = input.modelTo;
          }

          //en el caso de que el texto sea otro, aparte de "nombre" [default]
          if(input.itemText){
            obj.itemText = input.itemText;
          }

          //map es para convertir un array de obj en un array de ids (u otro atributo)
          //usado para multiSelect
          if(input.map){
            console.log("input map");
            obj.value = _.map(item[input.nameAttr], itemObj => {
              return itemObj[input.map]
            })
          }

          //nameAttrMap es el atributo que guardara el resultado
          //de un map, generalmente usado para multiSelect
          if(input.nameAttrMap){
            obj.prop = input.nameAttrMap;
          }

          //agrega los items del model en el atributo obj.list
          if(input.model){
            obj.model = input.model;
            if(self.listsModel[input.model] == undefined){
              obj.loading = true;
              self.importModel(input.model).then(model => {
                return model.default.all({
                  params:{empresa_id : self.empresaSelected.id}
                }).then( res => {
                  var data = res.data.data;
                  if(input.grouped){
                    data = _.flatMap(data);
                  }
                  self.listsModel[input.model] = data;
                  obj.loading                  = false;
                  obj.list                     = data;
                  self.$forceUpdate();
                })
              })
            }else{
              obj.list = self.listsModel[input.model];
            }
          }

          return obj;
        })
        //en las promesas, muchas veces vue no detecta cambios en variables nuevas
        //form es declarada al inicio de la funcion y actualizada en el $nextTick
        item.form = itemSelectedForm;
        this.$forceUpdate();
      })

      //return itemSelectedForm;
    },


    saveItem(item, callback){
      item.loading = true;
      item.saveError = false;
      this.loadingForm = true;
      var itemData = {};

      _.forEach(item.form, (node) =>{
        if(node.modelTo === undefined){
          itemData[node.prop] = node.value;
        }
      })


      return this.actualModel.saveOrAdd(itemData)
      .then(async res => {


        if(item.id === null && res.data.id){
          this.saveForm(item);
          item.id = res.data.id;
          await this.madeForm(item);
          item.isNew = false;
        }


        _.forEach(this.actualModel.relations, rel =>{
          //promises.push(node.model.saveOrAdd(node));
          var dataForm = _.filter(item.form, {modelTo: rel[0]});
          var data = {};
          var dataForm_id = null
          _.forEach(dataForm, (node) =>{
            var prop = _.last(node.prop.split("."));
            data[prop] = node.value;
            if(prop == "id"){
              dataForm_id = node;
            }
          })
          data[rel[1]] = item[rel[2]]; //id
          this.importModel(rel[0]).then(model => {
            return model.default.saveOrAdd(data).then(res => {
              if(res.data.id){
                item[_.camelCase(model.default.resource)].id = res.data.id;
                if(dataForm_id){
                  dataForm_id.value = res.data.id;
                }
              }
            });
          })
        })

        item.loading = false;
        this.loadingForm = false;
        callback(item);
      }, resError =>{
        console.error(resError);
        item.loading = false;
        item.saveError = true;
        this.loadingForm = false;
      });
    },

    saveForm(item){
      item.form.forEach(input=>{
        item[input.prop] = input.value;
      });
    },

    save(){
      this.saveItem(this.item, item => {
        this.dialog = false;
        this.$emit("change", item, this.itemForm);
      });
    },
    cancel(){
      this.dialog = false;
      this.$emit("change",null, this.itemForm)
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
